import { render } from "./ExportPotentialCard.vue?vue&type=template&id=4aa88916"
import script from "./ExportPotentialCard.vue?vue&type=script&lang=js"
export * from "./ExportPotentialCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__